var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _circle, _circle2, _circle3, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCargoShip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.418,
    x2: 145.759,
    xlinkHref: "#lg1",
    y1: 221.907,
    y2: 288.988
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.752,
    x2: 137.108,
    xlinkHref: "#lg1",
    y1: 279.425,
    y2: 308.671
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.752,
    x2: 137.108,
    xlinkHref: "#lg1",
    y1: 259.345,
    y2: 288.591
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.752,
    x2: 137.108,
    xlinkHref: "#lg1",
    y1: 239.265,
    y2: 268.511
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.752,
    x2: 137.108,
    xlinkHref: "#lg1",
    y1: 219.186,
    y2: 248.432
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.752,
    x2: 137.108,
    xlinkHref: "#lg1",
    y1: 199.106,
    y2: 228.352
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.775,
    x2: 87.742,
    xlinkHref: "#lg1",
    y1: 229.258,
    y2: 278.887
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.487,
    x2: 195.454,
    xlinkHref: "#lg1",
    y1: 229.258,
    y2: 278.887
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.417,
    x2: 261.758,
    xlinkHref: "#lg1",
    y1: 221.907,
    y2: 288.988
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8eac"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.751,
    x2: 253.107,
    xlinkHref: "#lg2",
    y1: 279.425,
    y2: 308.671
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.344,
    x2: 249.344,
    xlinkHref: "#lg2",
    y1: 262.009,
    y2: 302.009
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.137,
    x2: 248.637,
    xlinkHref: "#lg2",
    y1: 238.391,
    y2: 277.391
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.601,
    x2: 250.101,
    xlinkHref: "#lg2",
    y1: 224.961,
    y2: 266.961
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.642,
    x2: 252.142,
    xlinkHref: "#lg2",
    y1: 205.641,
    y2: 263.142
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.283,
    x2: 207.283,
    xlinkHref: "#lg2",
    y1: 250.482,
    y2: 253.732
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.24,
    x2: 312.24,
    xlinkHref: "#lg2",
    y1: 250.267,
    y2: 253.517
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.418,
    x2: 145.759,
    xlinkHref: "#lg1",
    y1: 121.609,
    y2: 188.69
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fa9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666ad6"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.207,
    x2: 133.707,
    xlinkHref: "#lg3",
    y1: 171.281,
    y2: 214.281
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.088,
    x2: 134.088,
    xlinkHref: "#lg3",
    y1: 159.634,
    y2: 192.634
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.652,
    x2: 135.652,
    xlinkHref: "#lg3",
    y1: 136.055,
    y2: 175.055
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.469,
    x2: 134.969,
    xlinkHref: "#lg3",
    y1: 117.351,
    y2: 155.351
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.265,
    x2: 134.765,
    xlinkHref: "#lg3",
    y1: 104.868,
    y2: 139.869
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.775,
    x2: 87.742,
    xlinkHref: "#lg3",
    y1: 128.96,
    y2: 178.589
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.487,
    x2: 195.454,
    xlinkHref: "#lg3",
    y1: 128.96,
    y2: 178.589
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.417,
    x2: 261.758,
    xlinkHref: "#lg1",
    y1: 121.609,
    y2: 188.69
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.408,
    x2: 249.408,
    xlinkHref: "#lg4",
    y1: 175.45,
    y2: 217.95
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.144,
    x2: 250.144,
    xlinkHref: "#lg4",
    y1: 157.101,
    y2: 197.602
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.344,
    x2: 249.844,
    xlinkHref: "#lg4",
    y1: 135.966,
    y2: 179.466
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.579,
    x2: 249.079,
    xlinkHref: "#lg4",
    y1: 112.261,
    y2: 161.261
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.318,
    x2: 248.318,
    xlinkHref: "#lg4",
    y1: 95.887,
    y2: 140.387
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.774,
    x2: 203.741,
    xlinkHref: "#lg4",
    y1: 128.96,
    y2: 178.589
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.641,
    x2: 313.641,
    xlinkHref: "#lg4",
    y1: 148.84,
    y2: 157.34
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.489,
    x2: 408.393,
    xlinkHref: "#lg1",
    y1: 148.611,
    y2: 211.38
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.629,
    x2: 400.129,
    xlinkHref: "#lg5",
    y1: 182.562,
    y2: 109.062
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.001,
    x2: 405.001,
    xlinkHref: "#lg6",
    y1: 134.69,
    y2: 150.684
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.418,
    x2: 358.085,
    xlinkHref: "#lg7",
    y1: 164.6,
    y2: 186.6
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.972,
    x2: 392.639,
    xlinkHref: "#lg7",
    y1: 164.6,
    y2: 186.6
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.527,
    x2: 427.193,
    xlinkHref: "#lg7",
    y1: 164.6,
    y2: 186.6
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.081,
    x2: 461.748,
    xlinkHref: "#lg7",
    y1: 164.6,
    y2: 186.6
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.489,
    x2: 408.393,
    xlinkHref: "#lg1",
    y1: 204.337,
    y2: 267.106
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.629,
    x2: 400.129,
    xlinkHref: "#lg5",
    y1: 238.288,
    y2: 164.788
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.001,
    x2: 405.001,
    xlinkHref: "#lg3",
    y1: 190.416,
    y2: 206.41
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.418,
    x2: 358.085,
    xlinkHref: "#lg7",
    y1: 220.326,
    y2: 242.326
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.972,
    x2: 392.639,
    xlinkHref: "#lg7",
    y1: 220.326,
    y2: 242.326
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.527,
    x2: 427.193,
    xlinkHref: "#lg7",
    y1: 220.326,
    y2: 242.326
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.081,
    x2: 461.748,
    xlinkHref: "#lg7",
    y1: 220.326,
    y2: 242.326
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.489,
    x2: 408.393,
    xlinkHref: "#lg1",
    y1: 260.063,
    y2: 322.832
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.629,
    x2: 400.129,
    xlinkHref: "#lg5",
    y1: 294.014,
    y2: 220.514
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.001,
    x2: 405.001,
    xlinkHref: "#lg6",
    y1: 246.141,
    y2: 262.136
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.418,
    x2: 358.085,
    xlinkHref: "#lg7",
    y1: 276.052,
    y2: 298.052
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.972,
    x2: 392.639,
    xlinkHref: "#lg7",
    y1: 276.052,
    y2: 298.052
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.527,
    x2: 427.193,
    xlinkHref: "#lg7",
    y1: 276.052,
    y2: 298.052
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.081,
    x2: 461.748,
    xlinkHref: "#lg7",
    y1: 276.052,
    y2: 298.052
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.043,
    x2: 310.388,
    xlinkHref: "#lg7",
    y1: 277.642,
    y2: 449.549
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.859,
    x2: 310.74,
    xlinkHref: "#lg6",
    y1: 354.615,
    y2: 458.97
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.89,
    x2: 331.525,
    xlinkHref: "#lg1",
    y1: 329.047,
    y2: 340.879
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.89,
    x2: 375.525,
    xlinkHref: "#lg1",
    y1: 329.047,
    y2: 340.879
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.89,
    x2: 419.525,
    xlinkHref: "#lg1",
    y1: 329.047,
    y2: 340.879
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.02,
    x2: 117.02,
    y1: 333.498,
    y2: 300.498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 202.484h99.425v100.398h-99.425z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 282.803h99.425v20.08h-99.425z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 262.723h99.425v20.08h-99.425z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 242.644h99.425v20.08h-99.425z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 222.564h99.425v20.08h-99.425z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 202.484h99.425v20.08h-99.425z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m72.422 202.399v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.142 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m180.133 202.399v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.141 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 202.484h99.425v100.398h-99.425z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 282.803h99.425v20.08h-99.425z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 262.723h99.425v20.08h-99.425z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 242.644h99.425v20.08h-99.425z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 222.564h99.425v20.08h-99.425z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 202.484h99.425v20.08h-99.425z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m188.42 202.399v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.141 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m296.132 202.399v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.141 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 102.186h99.425v100.398h-99.425z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 182.505h99.425v20.08h-99.425z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 162.425h99.425v20.08h-99.425z",
    fill: "url(#SVGID_19_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 142.346h99.425v20.08h-99.425z",
    fill: "url(#SVGID_20_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 122.266h99.425v20.08h-99.425z",
    fill: "url(#SVGID_21_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m80.708 102.186h99.425v20.08h-99.425z",
    fill: "url(#SVGID_22_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m72.422 102.101v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.142 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_23_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m180.133 102.101v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.141 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_24_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 102.186h99.425v100.398h-99.425z",
    fill: "url(#SVGID_25_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 182.505h99.425v20.08h-99.425z",
    fill: "url(#SVGID_26_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 162.425h99.425v20.08h-99.425z",
    fill: "url(#SVGID_27_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 142.346h99.425v20.08h-99.425z",
    fill: "url(#SVGID_28_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 122.266h99.425v20.08h-99.425z",
    fill: "url(#SVGID_29_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m196.707 102.186h99.425v20.08h-99.425z",
    fill: "url(#SVGID_30_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m188.42 102.101v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.141 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_31_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m296.132 102.101v100.484h8.287v-100.484c0-1.141-.925-2.066-2.065-2.066h-4.156c-1.141 0-2.066.925-2.066 2.066z",
    fill: "url(#SVGID_32_)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m322.75 144.698h165.009v53.039h-165.009z",
    fill: "url(#SVGID_33_)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m322.75 144.698v8.04l45 45h120.009v-53.04z",
    fill: "url(#SVGID_34_)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m490.001 152.738h-170c-5.523 0-10-4.477-10-10 0-5.523 4.477-10 10-10h170c5.523 0 10 4.477 10 10 0 5.522-4.478 10-10 10z",
    fill: "url(#SVGID_35_)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m361.76 181.277h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_36_)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m396.314 181.277h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c.001 2.794-2.264 5.059-5.059 5.059z",
    fill: "url(#SVGID_37_)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m430.869 181.277h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_38_)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m465.423 181.277h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_39_)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m322.75 200.424h165.009v53.039h-165.009z",
    fill: "url(#SVGID_40_)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m322.75 200.424v8.039l45 45h120.009v-53.039z",
    fill: "url(#SVGID_41_)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m490.001 208.463h-170c-5.523 0-10-4.477-10-10 0-5.523 4.477-10 10-10h170c5.523 0 10 4.477 10 10 0 5.523-4.478 10-10 10z",
    fill: "url(#SVGID_42_)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m361.76 237.003h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_43_)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m396.314 237.003h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c.001 2.794-2.264 5.059-5.059 5.059z",
    fill: "url(#SVGID_44_)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m430.869 237.003h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_45_)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m465.423 237.003h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_46_)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m322.75 256.15h165.009v53.039h-165.009z",
    fill: "url(#SVGID_47_)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m322.75 256.15v8.039l45 45h120.009v-53.039z",
    fill: "url(#SVGID_48_)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m490.001 264.189h-170c-5.523 0-10-4.477-10-10 0-5.523 4.477-10 10-10h170c5.523 0 10 4.477 10 10 0 5.523-4.478 10-10 10z",
    fill: "url(#SVGID_49_)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m361.76 292.729h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_50_)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m396.314 292.729h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c.001 2.794-2.264 5.059-5.059 5.059z",
    fill: "url(#SVGID_51_)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m430.869 292.729h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_52_)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m465.423 292.729h-16.674c-2.794 0-5.059-2.265-5.059-5.059v-10c0-2.794 2.265-5.059 5.059-5.059h16.674c2.794 0 5.059 2.265 5.059 5.059v10c0 2.794-2.265 5.059-5.059 5.059z",
    fill: "url(#SVGID_53_)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m.979 256.389 43.9 57.657c18.773 24.655 22.437 57.647 9.532 85.821-2.163 4.722 1.288 10.099 6.482 10.099h408.839c7.334 0 14.087-3.994 17.62-10.421l20.162-36.681c3.034-5.52 3.306-12.144.734-17.894l-14.479-32.37c-3.237-7.237-10.425-11.896-18.353-11.896h-244.568c-13.001 0-25.213-6.241-32.828-16.779l-13.279-18.376c-7.615-10.538-19.827-16.779-32.828-16.779h-147.158c-3.927-.002-6.155 4.494-3.776 7.619z",
    fill: "url(#SVGID_54_)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m61.968 361.641c.504 12.933-1.971 26.03-7.557 38.225-2.163 4.722 1.288 10.099 6.482 10.099h408.839c7.334 0 14.087-3.994 17.619-10.421l20.162-36.681c.22-.401.422-.809.613-1.221h-446.158z",
    fill: "url(#SVGID_55_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 328.059,
    cy: 332.031,
    fill: "url(#SVGID_56_)",
    r: 11.058
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.059,
    cy: 332.031,
    fill: "url(#SVGID_57_)",
    r: 11.058
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.059,
    cy: 332.031,
    fill: "url(#SVGID_58_)",
    r: 11.058
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m106.764 322.243c-39.727-43.3-87.342-63.764-106.334-70.663-.666 1.485-.596 3.304.549 4.808l43.9 57.657c18.773 24.655 22.437 57.647 9.532 85.821-3.727 3.727-1.087 10.099 4.183 10.099h57.59l4.38-10.681c10.736-26.181 5.33-56.19-13.8-77.041z",
    fill: "url(#SVGID_59_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCargoShip);
export default __webpack_public_path__ + "static/media/icon-cargo-ship.13fb0c5489d433cecf971a8f979b8be4.svg";
export { ForwardRef as ReactComponent };